import React from 'react';
import './ResumePage.css';

const ResumePage: React.FC = () => {
  return (
    <div className="page-container resume-page">
      <div className="resume-header">
        <div className="resume-header-content">
          <div className="header-text">
            <h1>Matthew Dabit's Resume</h1>
          </div>
          <div className="download-container">
            <a href="/resume.pdf" download className="download-button">
              Download Resume PDF
            </a>
          </div>
        </div>
      </div>

      <div className="resume-content">
        <div className="resume-section">
          <h2>Professional Summary</h2>
          <p>
            Experienced lead software engineer with expertise in full-stack development, machine
            learning, and data analysis. Passionate about creating efficient, scalable solutions to
            complex problems.
          </p>
        </div>

        <div className="resume-section">
          <h2>Skills</h2>
          <ul className="skills-list">
            <li>Programming Languages: Java, Python, TypeScript, JavaScript</li>
            <li>Web Development: Spring, FastAPI, Django, REST, gRPC GraphQL, React</li>
            <li>Data Science: Machine Learning, Data Analysis, Pandas, NumPy, Plotly</li>
            <li>DevOps: Docker, Kubernetes, CI/CD, GCP, AWS, Datadog, Opentracing</li>
            <li>Database: SQL, Spanner, BigQuery, Elasticsearch</li>
          </ul>
        </div>

        <div className="resume-section">
          <h2>Experience</h2>
          <div className="experience-item">
            <h3>Lead Software Engineer - Highnote</h3>
            <p className="date">2021 - Present</p>
            <ul>
              <li>
                Developed and deployed multiple machine learning models in production, independently
                managing the end-to-end CRISP-DM lifecycle, leveraging the data collected from the
                risk analysis platform
              </li>
              <li>
                Architected and built a risk analysis platform from the ground up using Java and
                GraphQL, enabling transaction analysis to enhance fraud detection and financial
                oversight
              </li>
              <li>
                Designed and implemented a customer-facing, real-time spend control system to
                proactively block transactions, ensuring secure and compliant financial operations
              </li>
              <li>
                Engineered a scalable queuing system from scratch, optimizing alerting and ensuring
                reliable, high-throughput handling of financial data
              </li>
              <li>
                Led and mentored a team of 5 engineers, driving collaboration, guiding technical
                decisions, promoting a culture of heavy documentation and ensuring high-quality
                delivery of complex projects
              </li>
            </ul>
          </div>

          <div className="experience-item">
            <h3>Software Engineer - Numerator</h3>
            <p className="date">2019 - 2021</p>
            <ul>
              <li>
                Accelerated MagicQuery performance using Minimum Spanning Trees optimizing data
                query efficiency and significantly reducing processing times for large-scale
                datasets in Vertica
              </li>
              <li>
                Developed new features for Insights platform built on Django, enabling comprehensive
                tracking of all user actions, enhancing platform analytics and improving customer
                engagement and system insights
              </li>
            </ul>
          </div>

          <div className="experience-item">
            <h3>Software Engineer - Citadel</h3>
            <p className="date">2017 - 2019</p>
            <ul>
              <li>
                Leveraged Kafka to automate and accelerate risk analysis processes for tickers,
                streamlining data pipelines and significantly reducing processing time for real-time
                financial insights
              </li>
              <li>
                Lead developer of a market news and alerts UI application consisted of several
                containerized Python Flask microservices and a UI developed with TypeScript and
                React
              </li>
              <li>
                Applied DevOps experience to introduce automated build and deployment processes to
                the team, leading to several other engineer teams seeking consultation
              </li>
            </ul>
          </div>

          <div className="experience-item">
            <h3>Software Engineer - ThoughtWorks</h3>
            <p className="date">2016 - 2017</p>
            <ul>
              <li>
                Streamlined the provisioning and migration process of a legacy enterprise system
                reducing build time from 6 months to under 3 hours
              </li>
              <li>
                Utilized proficiency in React, Java, Spring Boot, and SQL to transform legacy
                monolithic applications into modern, scalable solutions
              </li>
              <li>
                Led peer development team out of a productivity slump by introducing agile
                methodologies and TDD
              </li>
            </ul>
          </div>

          <div className="experience-item">
            <h3>Research Assistant - Ivry Lab, UC Berkeley</h3>
            <p className="date">2014 - 2016</p>
            <ul>
              <li>
                Conducted Transcranial Magnetic Stimulation(TMS) and Transcranial Direct Current
                Stimulation(tDCS) to study the efficacy of stimulation on the Motor Cortex.
              </li>
              <li>
                Researched the effects of tDCS on the brain and how it can improve visuo-motor
                learning.
              </li>
              <li>Created several applications using Python to carry out experiments.</li>
            </ul>
          </div>
        </div>

        <div className="resume-section">
          <h2>Education</h2>
          <div className="education-item">
            <h3>Bachelor of Arts in Cognitive Science and Computer Science</h3>
            <p>University of California, Berkeley - 2016</p>
          </div>
          <div className="education-item">
            <h3>Certificate in Machine Learning and Artificial Intelligence</h3>
            <p>University of California, Berkeley - 2025</p>
          </div>
          <div className="education-item">
            <h3>Nanodegree in Cloud Development</h3>
            <p>Udacity - 2020</p>
          </div>
        </div>
      </div>

      <div className="nanodegree-download">
        <h3>Cloud Development Nanodegree</h3>
        <a href="/nanodegree.pdf" download className="download-button">
          Download Nanodegree Certificate
        </a>
      </div>

      <div className="mlai-download">
        <h3>Machine Learning and Artificial Intelligence Certificate</h3>
        <a href="/mlai degree.pdf" download className="download-button">
          Download Machine Learning and Artificial Intelligence Certificate
        </a>
      </div>
    </div>
  );
};

export default ResumePage;
